import { inject, Injectable } from '@angular/core';
import { MountingAssistantType } from './mounting-assistant.type';
import { BehaviorSubject, Observable } from 'rxjs';
import { ProjectModel } from '@project/model/project.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastrService } from 'ngx-toastr';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { ProjectHeadVO } from '@project/model/vo/project.vo';
import { DeactivateProjectChangeActionService } from '@shared/service/deactivate-project-change-action.service';

export interface MountingAssistantData {
  assistant: MountingAssistantType;
  data: any;
}

@Injectable({ providedIn: 'root' })
export class MountingAssistantService {
  private _activeAssistant = new BehaviorSubject<MountingAssistantData | null>(null);

  private toastrService = inject(ToastrService);
  private localeResourceManager = inject(LocaleResourceManager);

  constructor(
    projectModel: ProjectModel,
    private deactivateProjectChangeActionService: DeactivateProjectChangeActionService,
  ) {
    projectModel.currentProject$.pipe(
      takeUntilDestroyed()
    ).subscribe((project) => this.stopIfNecessary(project));
  }

  public get activeAssistant$(): Observable<MountingAssistantData | null> {
    return this._activeAssistant.asObservable();
  }

  public start(assistant: MountingAssistantType, data?: any): void {
    if (this._activeAssistant.value?.assistant === assistant && !data) {
      return;
    }
    if (assistant === 'io') {
      this.toastrService.info(this.localeResourceManager.findValueByKey('mountingAssistant.io.loading_message'), '', { timeOut: 2000 });
    }
    this._activeAssistant.next({assistant, data});
  }

  public stop(): void {
    if(!!this._activeAssistant.value) {
      this._activeAssistant.next(null);
    }
  }

  private stopIfNecessary(project: ProjectHeadVO) {
    if (this._activeAssistant.value?.assistant !== 'cae' || project.caeType === undefined) {
      this.deactivateProjectChangeActionService.removeReasonToDeactivateProjectChangeAction('runningAssistant');
      this.stop();
    }
  }
}
